export const PLANNER_STYLE_FIELDS = ['styleCd', 'styleNm', 'originalStyleNo', 'genderCd', 'productYear', 'season', 'salesMonth', 'finalGrade', 'businessType', 'productType', 'styleKind', 'characteristic'];
export const PLANNER_ORDER_FIELDS = ['productionCategory', 'productionType', 'mdpType', 'mdpStartDate'];
export function emptyPlannerStyle(brandCd) {
    return { brandCd, styleCd: '', styleNm: '', originalStyleNo: '', genderCd: '', productYear: '', season: '', salesMonth: '', finalGrade: '', businessType: 'MAIN',
        productType: '', styleKind: '', characteristic: '', productionCategory: '', productionType: '', mdpType: '', mdpStartDate: '', salePrice: null, receivingDueDate: null,
        colors: [], sizes: [], quantities: [], people: { designerId: null, plannerId: null, purchasingId: null, productionId: null, patternId: null, cadId: null } };
}
export function plannerQuantityMatrix(data) {
    const cells = new Map(data.quantities.map(q => [JSON.stringify([q.tagColorCd, q.sizeCd]), q.qty]));
    return data.colors.flatMap(tagColorCd => data.sizes.map(sizeCd => ({ tagColorCd, sizeCd, qty: cells.get(JSON.stringify([tagColorCd, sizeCd])) ?? null })));
}
export function manualCommerceIssues(data) {
    const matrix = plannerQuantityMatrix(data);
    return [
        ...(!data.salePrice || Number(data.salePrice) <= 0 ? ['plannerStyle.priceRequired'] : []),
        ...(!matrix.length || matrix.some(q => q.qty === null) || matrix.reduce((sum, q) => sum + (q.qty ?? 0), 0) <= 0 ? ['plannerStyle.quantityRequired'] : []),
        ...(!data.receivingDueDate ? ['plannerStyle.dateRequired'] : []),
    ];
}
export function sheetManualCommerceIssues(sheet) {
    if (sheet.plannerOrderEditable === false || sheet.source !== 'MANUAL')
        return [];
    return manualCommerceIssues({ colors: sheet.matrixColors, sizes: sheet.matrixSizes, salePrice: sheet.salePrice, receivingDueDate: sheet.receivingDueDate,
        quantities: sheet.orderQuantities.map(q => ({ tagColorCd: q.tagColorCd, sizeCd: q.sizeCd, qty: q.qty })) });
}
//# sourceMappingURL=planner-style.js.map